import classNames from 'classnames';
import React from 'react';
import favoriteIcon from '../icons/non-prefilled/16x16/favorite.svg';
import prefilledFavoriteIcon from '../icons/prefilled/16x16/favorite.svg';
import styles from './FavoriteIcon.module.scss';
import SVGIcon from './SVGIcon';

type SVGIconProps = Omit<React.ComponentProps<typeof SVGIcon>, 'children'>;

interface FavoriteIconProps extends SVGIconProps {
  active?: boolean;
  prefilled?: boolean;
}

const FavoriteIcon = ({
  active = false,
  prefilled,
  ...props
}: FavoriteIconProps) => {
  return (
    <SVGIcon
      className={classNames(styles.icon, { [styles.active]: active })}
      {...props}
    >
      {prefilled ? prefilledFavoriteIcon : favoriteIcon}
    </SVGIcon>
  );
};

export default FavoriteIcon;
